import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { LearningPathMultiStepForm } from '../../app/components/learning-path/learning-path-multi-step-form';
import { trpc } from '@org/clients/school';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/learning-paths/new')({
  component: LearningPathCreateRoute,
});

function LearningPathCreateRoute() {
  const navigate = useNavigate({ from: '/learning-paths/new' });
  const utils = trpc.useUtils();
  const { t } = useTranslation('admin');

  const handleClose = () => {
    navigate({ to: '/learning-paths', replace: true });
  };

  const handleSubmit = async () => {
    await utils.learningPaths.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title={t('learningPaths.list.modal.createTitle')}
      size="xl"
      centered
      body={
        <LearningPathMultiStepForm
          defaultValues={{}}
          onSubmit={handleSubmit}
          onClose={handleClose}
          isEditing={false}
        />
      }
      footer={<></>}
    />
  );
}
